import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TimelineIcon from '@mui/icons-material/Timeline';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import { Link } from "react-router-dom";
import { ListItem } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

export default function ListItems2(props) {
  const [selectedIndex, setSelectedIndex] = React.useState(6);
  const privi = sessionStorage.getItem('_sr3')
  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);

  };

  return (
    <Box sx={{ width: '100%', maxWidth: 360, }}>
      <List component="nav" aria-label="main mailbox folders">
        <Link to="/incidencias" style={selectedIndex === 0 ? { color: '#008000', textDecorationLine: 'none' } : { color: 'white', textDecorationLine: 'none' }}>
          <ListItem button

            selected={selectedIndex === 0}
            onClick={(event) => handleListItemClick(event, 0)}
            style={selectedIndex === 0 ? { backgroundColor: '#fff' } : null}
          >
            <ListItemIcon >
              <DashboardIcon style={selectedIndex === 0 ? { color: '#008000' } : { color: '#fff' }} />
            </ListItemIcon>
            <ListItemText >Incidencias</ListItemText>
          </ListItem>
        </Link>
        <Link to="/historial" style={selectedIndex === 1 ? { color: '#008000', textDecorationLine: 'none' } : { color: 'white', textDecorationLine: 'none' }}>
          <ListItemButton
            selected={selectedIndex === 1}
            onClick={(event) => handleListItemClick(event, 1)}
            style={selectedIndex === 1 ? { backgroundColor: '#fff' } : null}
          >
            <ListItemIcon>
              <TimelineIcon style={selectedIndex === 1 ? { color: '#008000' } : { color: '#fff' }} />
            </ListItemIcon>
            <ListItemText primary="Historial" />
          </ListItemButton>
        </Link>
      </List>

      {privi === '13' ?
        <List component="nav" aria-label="secondary mailbox folder">
          <Link to="/usuarios" style={selectedIndex === 2 ? { color: '#008000', textDecorationLine: 'none' } : { color: 'white', textDecorationLine: 'none' }}>
            <ListItemButton
              selected={selectedIndex === 2}
              onClick={(event) => handleListItemClick(event, 2)}
              style={selectedIndex === 2 ? { backgroundColor: '#fff' } : null}
            ><ListItemIcon>
                <PersonIcon style={selectedIndex === 2 ? { color: '#008000' } : { color: '#fff' }} />
              </ListItemIcon>
              <ListItemText primary="Usuarios" />
            </ListItemButton>
          </Link>
        </List>
        : privi === '15' ?
          <List>
            <Link to="/usuarios" style={selectedIndex === 2 ? { color: '#008000', textDecorationLine: 'none' } : { color: 'white', textDecorationLine: 'none' }}>
              <ListItemButton
                selected={selectedIndex === 2}
                onClick={(event) => handleListItemClick(event, 2)}
                style={selectedIndex === 2 ? { backgroundColor: '#fff' } : null}
              ><ListItemIcon>
                  <PersonIcon style={selectedIndex === 2 ? { color: '#008000' } : { color: '#fff' }} />
                </ListItemIcon>
                <ListItemText primary="Usuarios" />
              </ListItemButton>
            </Link>
          </List> : null
      }

      <List component="nav" aria-label="secondary mailbox folder">
        <Link to="/setings" style={selectedIndex === 3 ? { color: '#008000', textDecorationLine: 'none' } : { color: 'white', textDecorationLine: 'none' }}>
          <ListItemButton
            selected={selectedIndex === 3}
            onClick={(event) => handleListItemClick(event, 3)}
            style={selectedIndex === 3 ? { backgroundColor: '#fff' } : null}
          ><ListItemIcon>
              <MiscellaneousServicesIcon style={selectedIndex === 3 ? { color: '#008000' } : { color: '#fff' }} />
            </ListItemIcon>
            <ListItemText primary="Acerca de" />
          </ListItemButton>
        </Link>
      </List>
    </Box>
  );
}